function isAndroidDevice() {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes('android');
}

function isInAppBrowser() {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes('wv') ||
         userAgent.includes('micromessenger') ||
         userAgent.includes('qq/') ||
         userAgent.includes('snapchat') ||
         userAgent.includes('instagram') ||
         userAgent.includes('fbav') ||
         userAgent.includes('twitter') ||
         window.navigator.standalone === true;
}

function handleOAuthError() {
  const params = new URLSearchParams(window.location.search);
  const errorKey = params.get('error');

  if (errorKey) {
    const errorMessages = {
      'login_failed': 'Authentication via the third-party service failed. Please try again or use the form below.',
      'default': 'An unknown error occurred. Please try again.'
    };

    const errorContainer = document.getElementById('oauth-error-message');
    const message = errorMessages[errorKey] || errorMessages['default'];

    if (errorContainer) {
      errorContainer.innerHTML = message;
      errorContainer.style.display = 'block';
    }
  }
}

function hideUnavailableLoginOptions(containerSelector, providerSelector, appleSelector, googleSelector) {
  const container = document.getElementById(containerSelector);
  const appleBtn = document.querySelector(appleSelector);
  const googleBtn = document.querySelector(googleSelector);

  if (isInAppBrowser() && googleBtn) {
    googleBtn.style.display = 'none';
  }

  if (isAndroidDevice() && appleBtn) {
    appleBtn.style.display = 'none';
  }

  setTimeout(() => {
    const visibleProviders = document.querySelectorAll(`${providerSelector}:not([style*="display: none"])`);
    if (visibleProviders.length === 0 && container) {
      container.style.display = 'none';
      const separator = container.nextElementSibling;
      if (separator && separator.style) {
        separator.style.display = 'none';
      }
    }
  }, 100);
}